import { makeStyles, Paper, Table, TableBody, TableContainer } from '@material-ui/core';
import React from 'react';

export function TableElement({ children }: { children?: React.ReactNode }): React.ReactElement {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.root}>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    tableLayout: 'fixed',
  },
}));
